import { useColorModeSupport } from './useColorModeSupport';

export function ColorModeHandler() {
    useColorModeSupport();
    return null;
}
